import { JobPost } from "@prisma/client";
import { gtagEvent } from "@services/googleAnalytics";
import { mixpanelEvent } from "@services/mixpanel";
import { classNames } from "@utils/classNames";
import { AnalyticsEvent } from "@utils/redis/analytics/AnalyticsEvent";
import React, { FC } from "react";

interface Props {
  id: JobPost["id"];
  applyUrl: string;
  cN?: string;
}

export const Apply: FC<Props> = ({ id, applyUrl, cN }) => (
  <a
    className={classNames(
      "px-4 py-4 bg-black border border-black text-white font-medium rounded-md hover:bg-transparent hover:text-black",
      cN
    )}
    href={applyUrl}
    rel="nofollow noopener noreferrer"
    target={"_blank"}
    onClick={(e) => {
      // Google analytics: Record job post apply.
      gtagEvent({
        name: "add_to_cart",
        payload: {
          items: [{ id }],
        },
      });

      // Mixpanel: Record job post apply.
      mixpanelEvent({
        name: AnalyticsEvent.JOB_POST_APPLY,
        payload: {
          id,
        },
      });

      // Internal analytics: Record job post apply.
      fetch("/api/analytics/collect", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event: AnalyticsEvent.JOB_POST_APPLY,
          ids: [id],
        }),
      });
    }}
  >
    Apply
  </a>
);
